import { Component, ViewChild } from '@angular/core';
import { IDateParams } from '@ag-grid-community/core';
import { IDateAngularComp } from '@ag-grid-community/angular';
import { PFieldDateComponent } from '@frontend-site/ui/components';

@Component({
    selector: 'p-custom-date-filter',
    template: `<p-field-date
        #pFieldDate
        (dateChange)="onDateChanged($event)"
        [datePickerPanelClass]="'ag-custom-component-popup'"
    ></p-field-date> `
})
export class PCustomDateFilterComponent implements IDateAngularComp {
    private date: Date | null = null;
    private params!: IDateParams;
    @ViewChild('pFieldDate') pFieldDate!: PFieldDateComponent;

    agInit(params: IDateParams): void {
        this.params = params;
    }

    onDateChanged(selectedDate: Date) {
        this.date = selectedDate || null;
        this.params.onDateChanged();
    }

    getDate(): Date | null {
        return this.date;
    }
    setDate(date: Date): void {
        this.date = date || null;
        if (!this.date) {
            this.pFieldDate.clearValue();
        }
    }
}
